<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>


    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
        data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
        <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>About the post</h1>
                    </div>
                </div>
            </div>

        </div>

    </section>
    <!-- section close -->



    <div class="row notifi_main ">
        <div class="col-md-12">
            <h2>
                Consultants (Technical Support )
            </h2>

            <p class="para_main_notify">
                The engagement of Non- Training Profile Consultants (Technical Support ) to be engaged in RDSDEs and DGT
                HQRs.
            </p>
        </div>
    </div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="row sequence">

                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Qualifications and experience:</h3>

                                    <p> <span class="step_no">1</span> 1. B.Tech / B.E (having minimum of 2 years of
                                        Experience) / Diploma (having minimum of 5 years of Experience) / CITS with at
                                        least 3 years of experience in the requisite field. </p>
                                    <p> <span class="step_no">2</span> 2. Retired Government employees with Level 7 and
                                        above in the Pay Matrix, having experience of at least 5 years in the required
                                        domain field would also be eligible for the position. </p>
                                    <p> <b> Note: </b>The candidature of the candidate who is appearing in exam for JCs
                                        of training profiles, shall be cancelled if the candidate fails in practical
                                        examination i.e., Qualifying practical examination is mandatory for Training
                                        profile JCs. </p>


                                </div>
                            </div>
                        </div> -->
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>General Conditions </h3>



                                    <p> <span class="step_no">1</span>Consultants will be engaged for a period of eleven
                                        months from the date of Engagement. </p>
                                    <p> <span class="step_no">2</span> The services of Consultants may be continued for
                                        a period of another 11 Months with a
                                        break of 1 Month if found suitable by the competent authority of RDSDE/DGT </p>
                                    <p> <span class="step_no">3</span> Consultants shall be appointed on a full-time
                                        basis and would not be permitted to take up any
                                        other assignment during the period of Consultancy.
                                    </p>
                                    <p> <span class="step_no">4</span> The engagement is purely on temporary nature and
                                        the appointment can be cancelled at any
                                        time without providing any reason for it. </p>
                                    <p> <span class="step_no">5</span> The reservation policy applicable for Central
                                        Government services should be strictly followed
                                        in the selection process of Consultants </p>
                                    <p> <span class="step_no">6</span> An agreement on stamp paper of Rs.100 /- duly
                                        notarized, must be signed between the
                                        Director of the Institute and incumbent (Consultant).
                                    </p>
                                    <p> <span class="step_no">7</span> A waitlist of qualified candidates (nearly 2
                                        times the no. of vacancy of Consultants) is to
                                        be prepared & should kept in panel for three years. They will be considered
                                        against
                                        transfer, resignation, death etc cases. </p>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Number of Consultants:</h3>
                                    <p> The total number of consultants to be engaged shall depend on the actual
                                        requirement at a particular
                                        point of Time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Qualification and Experience: </h3>
                                    <p> <span class="step_no">1</span> An Engineering Graduate (BE/B.Tech) with at least
                                        5 year of experience in relevant field </p>
                                    <p> <span class="step_no">2</span>M.Tech
                                        or above with at least 2 years of experience in relevant field
                                    </p>
                                    <p> <span class="step_no">3</span>Diploma with at least 7 years of
                                        experience in relevant field
                                    </p>
                                    <p> <span class="step_no">4</span>BBA with at least 5-year experience in relevant
                                        field
                                    </p>
                                    <p> <span class="step_no">5</span>MBA with at
                                        least 2 years of experience in relevant field
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->

                                                  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 31st July 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                          <div class="feature-box style-2 left">
                              <i class="fa fa-gavel"></i>
                              <div class="text para_cls">
                                  <h3>Age Limit: </h3>
                                  <p>  Upper Age limit of 40 Years for all as on Last date of receipt of Application (Except for Retired Govt Servant) </p>

                              </div>
                          </div>
                      </div>
                      <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-cogs"></i>
                                <div class="text para_cls">
                                    <h3>Required Skills:</h3>
                                    <p><span class="step_no">1</span>Should be having Strong analytical skills, expert
                                        in Microsoft Office Tools, Documentation Skills,
                                        coordination, policy formation and analysis, planning, advertisement /public
                                        skill, IT skills,
                                    </p>
                                    <p><span class="step_no">2</span> Candidate must be capable of leading the
                                        development teams. Candidate must have Strong verbal / written
                                        communication, presentation and written communication skills
                                    </p>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3>Score Card Calculations</h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Examination/Experience/Qualification </th>
                                                        <th style="text-align: center;">Split up</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>CBT Examination (Maximum120 Marks) </td>
                                                        <td>Total CBT Marks obtained out of 120
                                                            Marks </td>
                                                    </tr>

                                                    <!-- <tr>
                                                        <td>2</td>
                                                        <td>Proficiency Skill Test Interview by Expert
                                                            Committee (Maximum 30 Marks) </td>
                                                        <td> Total Marks obtained out of 30 Marks
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Qualification Marks (Maximum 30 Marks) </td>
                                                        <td>
                                                            <p>Marks will be provided on the basis of
                                                                Percentage obtained in the last qualification
                                                                of the candidates using the given formula
                                                            </p>
                                                            <p> Formula = [0.3*(Absolute Percentage
                                                                obtained in the Last qualification)] Marks</p>
                                                            <p>Note: CGPA/SGPA should be converted into
                                                                absolute percentage by using Institute
                                                                Conversion Formula.</p>
                                                        </td>

                                                    </tr> -->
                                                    <tr>
                                                        <td>2</td>
                                                        <td>Experience
                                                            (Maximum 20 Marks) </td>
                                                        <td>
                                                            <p> 4 Marks per year of Experience after
                                                                acquiring minimum qualification &
                                                                experience as prescribed in Para C above. </p>
                                                            <p> (Maximum limit is 20 Marks for 5 years of
                                                                experience after acquiring minimum
                                                                qualification & experience as prescribed in
                                                                Para C above.) </p>
                                                        </td>

                                                    </tr>
                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td>Total Marks </td>
                                                        <td class="num_marks"> 200 </td>
                                                        <td></td>
                                                    </tr>

                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> proposed process </h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Activity/Process </th>
                                                        <th>Timelines</th>
                                                        <th style="text-align: center;">To be done by</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>Organisation-wise Requirement of Consultants </td>
                                                        <td></td>
                                                        <td>by CFI Division </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Publishing of the Applications Centrally Online
                                                            for engaging Consultants </td>
                                                        <td></td>
                                                        <td> by NIMI
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Scrutinizing of Applications received, Issue
                                                            of Admit Card </td>
                                                        <td></td>
                                                        <td> by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>Conduct of All India CBT Exam for selection of pool
                                                            of candidates Online </td>
                                                        <td></td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>Conduct of Proficiency Skill Test Interview for
                                                            candidates (6 times the number of vacancies) </td>
                                                        <td></td>
                                                        <td>
                                                            by the
                                                            Committee
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>Calculation of Score Card/Result of the Candidates (3
                                                            Times the number of Consultants) in order of merit as per
                                                            the Score card rule mentioned in Consultants guidelines
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>Selected candidates Panel list (3 Times the number of
                                                            Consultants) with scorecard to be sent from NIMI to DGT
                                                            HQRS for approval </td>
                                                        <td></td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div> -->
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Tie Breaker Rules</h3>


                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                In case of tie between the Marks of set of candidates, the following
                                                criteria will be applicable in
                                                Priority basis to settle the tie
                                            </div>
                                            <div class="col-md-12">
                                                <table>

                                                    <tr>
                                                        <td>1</td>
                                                        <td> First Preference </td>
                                                        <td> CBT marks
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Second Preference </td>
                                                        <td>Experience/Relevance to desired skill set </td>

                                                    </tr>

                                                    <tr>
                                                        <td>3</td>
                                                        <td>Third Preference </td>
                                                        <td>Degree or Higher qualification in relevant field </td>


                                                    </tr>

                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Entitlements of Consultants: </h3>
                                    <p> <span class="step_no">1</span> The full-time candidates will be paid a monthly
                                        consolidated remuneration of Rs. 45000/ </p>
                                    <p> <span class="step_no">2</span>The Consultants will not be eligible for
                                        Government Accommodation or House Rent
                                        Allowance, CGHS facility Official email i.d., Government identification card,
                                        internet
                                        connection, telephone, etc.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->
                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> TA/DA:</h3>
                                    <p> If the Tour program is in interest of Public Service, then they are entitled to
                                        allowances as applicable
                                        in the Level-6/7 as applicable
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Leave: </h3>
                                    <p> The Consultants shall be entitled to leave of 8 days in a year on pro rata
                                        basis. Additional leave
                                        without pay would be permitted upon approval by the Concerned Competent
                                        Authority.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Conflict of interest:
                                    </h3>
                                    <p> He/she will be expected to display utmost honesty, secrecy of office and
                                        sincerely while discharging
                                        his/her duties. In case, the services of the Consultant are not found
                                        satisfactory or found in conflict
                                        with the interests of the Government, his/her services will be liable for
                                        discontinuation without
                                        assigning any reason.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Termination Notice:
                                    </h3>
                                    <p> The Competent Authority can cancel the appointment at any time without providing
                                        any reason for
                                        it. However, in the normal course it will provide one month’s notice to the
                                        Consultant.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> Engagement of Consultants in DGT Hqrs: </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>DGT(HQ) </th>
                                                        <th>Consultant (Technical
                                                            Support) </th>
                                                        <th>No of
                                                            Consultants </th>
                                                        <th style="text-align: center;"> 15</th>
                                                    </thead>





                                                </table>




                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> Engagement of Consultants in RDSDE: </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Name of RDSDE </th>
                                                        <th>Headquarters </th>
                                                        <th>No.of
                                                            Consultants
                                                            to be engaged </th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>RDSDE Andhra Pradesh </td>
                                                        <td>Vijayawada</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>RDSDE Assam </td>
                                                        <td>Guwahati</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>RDSDE Bihar </td>
                                                        <td>Patna</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>RDSDE Chhattisgarh </td>
                                                        <td>Raipur</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>RDSDE Gujarat </td>
                                                        <td>Gandhi Nagar</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>RDSDE Haryana </td>
                                                        <td>Chandigarh</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>RDSDE Himachal Pradesh </td>
                                                        <td>Shimla</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>RDSDE Jammu & Kashmir </td>
                                                        <td>Jammu</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>RDSDE Jharkhand </td>
                                                        <td>Ranchi</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>RDSDE Karnataka </td>
                                                        <td>Bengaluru</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>RDSDE Kerala </td>
                                                        <td> Thiruvananthapuramam </td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>RDSDE Madhya Pradesh </td>
                                                        <td>Bhopal</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>RDSDE Maharashtra </td>
                                                        <td>Mumbai</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>RDSDE Odisha </td>
                                                        <td>Bhubaneswar</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>RDSDE Punjab </td>
                                                        <td>Ludhiana</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>RDSDE Rajasthan </td>
                                                        <td>Jaipur</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>RDSDE Tamil Nadu </td>
                                                        <td>Chennai</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td>RDSDE Telangana </td>
                                                        <td>Hyderabad</td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>RDSDE Uttarakhand </td>
                                                        <td> Dehradun </td>
                                                        <td>1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>RDSDE Uttar Pradesh </td>
                                                        <td>Kanpur</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td>RDSDE West Bengal </td>
                                                        <td>Kolkata</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td>RDSDE (National Capital Region) </td>
                                                        <td>Faridabad</td>
                                                        <td>2 </td>
                                                    </tr>
                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td> </td>
                                                        <td></td>
                                                        <td>33 </td>
                                                    </tr>



                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                         <!-- feature box begin -->
                         <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> Note : </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                               <p>The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation</p>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->
                        

                    </div>
                </div>

                <!-- <div class="col-md-4">
      <figure class="picframe invert transparent hover-shadow rounded">
                            <span class="overlay-v">
            <span class="v-center">
              <span>
                <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                  <span></span>
                </a>
              </span>
            </span>
          </span>
                        <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                    </figure>
    </div> -->
            </div>

        </div>
    </section>
    <!-- section close -->







</div>
<!-- content close -->




<style>
    #section-intro {
        background-image: url(assets/images/background/niminew.jpg);
        background-size: cover;
        background-position: 0% 0px;
        height: 80vh !important;
    }

    .notifi_main {
        text-align: center;
        padding: 40px 0px;
    }

    .notifi_main h2 {
        border-bottom: 6px solid #F56B55;
        width: fit-content;
        margin: 0 auto;
        padding: 0px 30px;
    }

    .notifi_main .descrip_cls {
        padding: 5px 0px;
        font-weight: 500;
        font-size: 21px;
    }

    .overlay-bg.t50 {
        background: rgba(30, 30, 30, .1);
    }

    table {
        width: 100%;
        margin-top: 10px;
    }

    th,
    td {
        padding: 10px;
    }

    thead {
        background-color: #F56B55;
        color: #fff;
    }

    tr:nth-child(odd) {
        background-color: #eee;
    }

    .step_no {
        left: 80px;
        height: 30px;
        width: 30px;
        background-color: #F56B55;
        border-radius: 50%;
        display: inline-block;
        font-size: 18px;
        text-align: center;
        color: #fff;
        margin-right: 10px;
        position: absolute;
    }

    .para_cls p {
        padding-left: 35px;
    }

    .num_marks {
        text-align: center;
    }

    .last_tr {
        background-color: #F56B55 !important;
        color: #fff;
    }

    .notifi_main_table h2 {

        width: fit-content;
        margin: 0 auto;
        padding: 50px 30px 10px;
        font-size: 23px;

    }

    .para_main_notify {
        padding: 20px 0px;
        width: 50%;
        margin: 0 auto;
    }

    #section-services {
        padding: 0px !important;
    }
</style>
